import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent' 
import DialogTitle from '@material-ui/core/DialogTitle' 
import ExitToAppIcon from '@material-ui/icons/ExitToApp'

const VideoDialog = ({open, handleClose, description, name}) => { 
    return (<Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle>{name}</DialogTitle>
        <DialogContent>
            <div>{description}</div>
        </DialogContent>
        <DialogActions> 
        <Button startIcon={<ExitToAppIcon />} variant="contained" onClick={handleClose} color="primary" autoFocus>
            Close
        </Button>
        </DialogActions>
    </Dialog>) 
}

export default VideoDialog